import $ from 'jquery';

let mobileAppBanner = function() {
    if ($.smartbanner !== undefined) {
      $.smartbanner({
        appendToSelector: '#main-nav',
        title: 'myHP',
        icon: '/ucm/groups/public/@hp/@public/documents/images/android-touch-icon.png',
        daysHidden: 15,
        daysReminder: 90
      });
    }
  },
  mobileSearchToggle = function() {
    $('.search-toggle').on('click', function(event) {
      event.preventDefault();
      $('#mobile-header, #mobile-header-search').slideToggle('fast');
    });
  },
  mobileLogonToggle = function() {
    $('#mobile-logon').on('click', function(event) {
      event.preventDefault();
      $('.logon-block').addClass('active');
      $('#logon-drawer').slideDown('fast');
    });

    $('.close-logon').on('click', function(event) {
      event.preventDefault();
      $('.logon-block').removeClass('active');
      $('#logon-drawer').slideUp('fast');
    });

    $('.mobile-logon-toggle').on('click', function(event) {
      event.preventDefault();
      $('#mobile-logon-btn, .logon-box').toggle();
    });
  },
  mobileNav = function() {
    $('.navbar-offcanvas').on('show.bs.offcanvas', function(e) {
      $('.mobile-backdrop').addClass('in');
      $('#mobile-button').html('X');
    });

    $('.navbar-offcanvas').on('hide.bs.offcanvas', function(e) {
      $('.mobile-backdrop').removeClass('in');
      $('#mobile-button').html('Menu');
    });

    //inpage navigation hide/show event
    $('.mobile-expand').on('click', function(event) {
      event.preventDefault();
      $(this).toggleClass('open');
      $('.menu-block-wrapper, .views-widget').toggleClass('content-showing');
    });

    //GLOBAL MOBILE NAV
    $('.level-one > .mobile-expand-global').on('click', function(event) {
      event.preventDefault();
      $(this)
        .parent()
        .siblings()
        .removeClass('open');
      $(this)
        .parent()
        .siblings()
        .children()
        .removeClass('content-showing');
      $('.level-two .mobile-block-wrapper-two').removeClass('content-showing');
      $(this)
        .parent()
        .toggleClass('open');
      $(this)
        .next('.mobile-block-wrapper')
        .toggleClass('content-showing');
    });

    //get the url full path and check to see if any anchor tags match it. If so add the active trail class.
    var full_path = location.href.split('#')[0];
    $('.menu li a').each(function() {
      var el = $(this);
      if (
        el.prop('href').split('#')[0] === full_path ||
        el.prop('href').split('#')[0] === full_path + 'index.html'
      ) {
        el.addClass('active-trail');
      }
    });
  },
  desktopNav = function() {
    // Restore "clickable parent links" in desktop navigation
    $('.hovernav a').click(function() {
      window.location = this.href;
    });
  },
  backTop = function() {
    // browser window scroll (in pixels) after which the "back to top" link is shown
    var offset = 300,
      //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
      offset_opacity = 1200,
      //duration of the top scrolling animation (in ms)
      scroll_top_duration = 700,
      //grab the "back to top" link
      $back_to_top = $('.cd-top');

    //hide or show the "back to top" link
    $(window).scroll(function() {
      $(this).scrollTop() > offset
        ? $back_to_top.addClass('cd-is-visible')
        : $back_to_top.removeClass('cd-is-visible cd-fade-out');
      if ($(this).scrollTop() > offset_opacity) {
        $back_to_top.addClass('cd-fade-out');
      }
    });

    //smooth scroll to top
    $back_to_top.on('click', function(event) {
      event.preventDefault();
      $('html, body').animate({scrollTop: 0}, 500);
      $('.navbar-brand').trigger('focus');
    });
  },
  mobilePagination = function() {
    $('.pagination-responsive').each(function() {
      var listItems = $(this).children();
      if (listItems.length % 2 === 0) {
        $(this).addClass('even');
      } else {
        $(this).addClass('odd');
      }
    });
  };

export default function() {
  mobileNav();
  desktopNav();
  backTop();
  mobilePagination();
  mobileSearchToggle();
  mobileLogonToggle();
  mobileAppBanner();
}



// WEBPACK FOOTER //
// ./src/webpack/components/hp-nav.js